import { NgModule } from '@angular/core';
import { CoreModule } from '@app/core/core.module';

import { KnowledgeBaseRoutingModule } from './knowledge-base-routing.module';

import { KnowledgeBaseComponent } from './components/home/knowledge-base.component';
import { KnowledgeBaseAiComponent } from './components/ai/knowledge-base-ai.component';
import { ViewKnowledgeBaseComponent } from './components/view-knowledge-base/view-knowledge-base.component';
import { KnowledgeBaseFilterPipe } from './components/pipes/knowledge-base-filter.pipe';


@NgModule({
  declarations: [
    KnowledgeBaseComponent,
    ViewKnowledgeBaseComponent,
    KnowledgeBaseFilterPipe,
    KnowledgeBaseAiComponent
  ],
  imports: [
    CoreModule,
    KnowledgeBaseRoutingModule
  ]
})
export class KnowledgeBaseModule { }
